import React from "react";
import { Segment, Header, Icon } from "semantic-ui-react";
import "./CoursesGrid.scss";

export function CoursesGrid(props) {
  const { courses } = props;

  // Get grade color class
  const getGradeClass = (grade) => {
    if (grade >= 16) return "excellent";
    if (grade >= 13) return "good";
    if (grade >= 11) return "warning";
    return "danger";
  };

  return (
    <Segment className="dashboard-segment">
      <Header as="h3" dividing>
        <Icon name="book" />
        Mis Cursos
      </Header>
      {courses?.length > 0 ? (
        <div className="courses-grid">
          {courses.map((course) => (
            <div className="course-card" key={course.courseId}>
              <div className="course-header">
                <span className="course-name">{course.subjectName}</span>
                <span
                  className={`course-grade ${getGradeClass(
                    course.averageGrade
                  )}`}
                >
                  {course.averageGrade?.toFixed(1) || "-"}
                </span>
              </div>
              <div className="course-teacher">
                <Icon name="user" size="small" />{" "}
                {course.teacher
                  ? `${course.teacher.firstname} ${course.teacher.lastname}`
                  : "Sin asignar"}
              </div>
              <div className="course-progress">
                <div className="progress-label">
                  <span>{course.performanceLevel || "Sin evaluar"}</span>
                  <span>
                    {course.averageGrade
                      ? `${((course.averageGrade / 20) * 100).toFixed(0)}%`
                      : "0%"}
                  </span>
                </div>
                <div className="progress-bar">
                  <div
                    className={`fill ${getGradeClass(course.averageGrade)}`}
                    style={{
                      width: `${
                        course.averageGrade
                          ? (course.averageGrade / 20) * 100
                          : 0
                      }%`,
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <Icon name="folder open outline" />
          <p>No tienes cursos asignados.</p>
        </div>
      )}
    </Segment>
  );
}
